export class ContactUsForm {
    message: string;
    topic: string;
    productType?: string;
    serviceType?: string;
    firstName: string;
    lastName: string;
    email: string;
    telephone: string;
    company: string;
    address: string;
    city: string;
    zipCode: string;
    industry: string;
    country: string;
    serviceUpdates: boolean;
}
